import React from 'react'
import About from '../AboutUsComponents/About'
import AboutCampagin from '../AboutUsComponents/AboutCampagin'
import BeVolunteer from '../AboutUsComponents/BeVolunteer'
import OurLocation from '../AboutUsComponents/OurLocation'
import BePartner from '../AboutUsComponents/BePartner'


function AboutUs() {
    return (
        <>
            <About />
            <AboutCampagin />
            <BeVolunteer />
            <OurLocation />
            <BePartner />
        </>
    )
}

export default AboutUs